import { useEffect, useRef, useState } from "react";

interface MultiSelectFilterProps {
  placeholder: string;
  options: string[];
  value: string[];
  onChange: (value: string[]) => void;
}

function MultiSelectFilter({
  placeholder,
  options,
  value,
  onChange,
}: MultiSelectFilterProps) {
  const [isOpen, setIsOpen] =
    useState(false);

  const [search, setSearch] =
    useState("");

  const dropdownRef =
    useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(
      event: MouseEvent
    ) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(
          event.target as Node
        )
      ) {
        setIsOpen(false);
      }
    }

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () =>
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
  }, []);

  const filteredOptions =
    options.filter((option) =>
      option
        .toLowerCase()
        .includes(search.toLowerCase())
    );

  function toggleValue(
    option: string
  ) {
    if (value.includes(option)) {
      onChange(
        value.filter(
          (item) => item !== option
        )
      );
      return;
    }

    onChange([...value, option]);
  }

  return (
    <div
      className="multi-filter"
      ref={dropdownRef}
    >
      <button
        type="button"
        className={`multi-filter-trigger ${value.length > 0
            ? "multi-filter-trigger--active"
            : ""
          }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="multi-filter-text">
          {value.length === 0
            ? placeholder
            : value.length === 1
              ? value[0]
              : `${value[0]} +${value.length - 1}`}
        </span>

        <span>▼</span>
      </button>

      {isOpen && (
        <div className="multi-filter-menu">

          <div className="multi-filter-search">
            <input
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) =>
                setSearch(
                  e.target.value
                )
              }
            />
          </div>

          <div className="multi-filter-options">

            {filteredOptions.map(
              (option) => (
                <label
                  key={option}
                  className="multi-filter-option"
                >
                  <input
                    type="checkbox"
                    checked={value.includes(
                      option
                    )}
                    onChange={() =>
                      toggleValue(
                        option
                      )
                    }
                  />

                  <span>
                    {option}
                  </span>
                </label>
              )
            )}

          </div>

        </div>
      )}
    </div>
  );
}

export default MultiSelectFilter;